
import type { PerformanceCore } from './performanceCore';
import type { PerformanceMetricsStore } from './performanceMetricsStore';

/**
 * Tracks paint timing metrics
 */
export class PerformancePaintTracker {
  private core: PerformanceCore;
  private metricsStore: PerformanceMetricsStore;
  
  constructor(core: PerformanceCore, metricsStore: PerformanceMetricsStore) {
    this.core = core;
    this.metricsStore = metricsStore;
  }
  
  /**
   * Track paint timing metrics from PerformanceObserver
   */
  trackPaintTiming(entry: PerformancePaintTiming) {
    try {
      // Update metrics store
      if (entry.name === 'first-contentful-paint') {
        this.metricsStore.updateMetrics({
          firstContentfulPaint: entry.startTime
        });
      }
      
      // Only track if core is properly initialized
      if (this.core && typeof this.core.trackPerformanceEvent === 'function') {
        this.core.trackPerformanceEvent({
          category: 'performance', // Add the required category property
          action: 'paint',
          label: entry.name,
          value: Math.round(entry.startTime),
          metadata: {
            name: entry.name,
            duration: entry.duration,
            startTime: entry.startTime
          }
        });
      } else {
        console.warn('Performance core not initialized, cannot track paint timing');
      }
    } catch (error) {
      console.error('Error tracking paint timing:', error);
    }
  }
}
